import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { buyers, images } from "../data/content";
type Notice = {
  name: string;
  country: string;
  flag: string;
  minutes: number;
};
function randomNotice(prev?: Notice): Notice {
  let b = buyers[Math.floor(Math.random() * buyers.length)];
  if (prev && b.name === prev.name) b = buyers[(buyers.indexOf(b) + 1) % buyers.length];
  return {
    ...b,
    minutes: 1 + Math.floor(Math.random() * 9)
  };
}
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setNotice(prev => randomNotice(prev ?? undefined));
      hideTimer = window.setTimeout(() => setNotice(null), 5000);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 14000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed left-3 right-3 top-3 z-50 sm:left-5 sm:right-auto sm:top-auto sm:bottom-28" aria-live="polite" data-id="element-45" data-mp="1fvsnt3ix9kny">
      <AnimatePresence data-id="element-46" data-mp="1axqyi0uwkp41">
        {notice && !dismissed && <motion.div key={notice.name + notice.minutes} initial={{
        opacity: 0,
        y: -16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl border border-black/5 bg-white p-2.5 pr-9 shadow-[0_12px_40px_rgba(0,0,0,0.45)] sm:max-w-sm" data-id="element-47" data-mp="n6v6p3qg5tws">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-navy object-contain p-1" data-id="element-48" data-mp="23ln0nl38r987" />
            <div className="min-w-0 text-left" data-id="element-49" data-mp="2ap32fekxwyda">
              <p className="text-[13px] leading-snug text-slate-800" data-id="element-50" data-mp="2aobbwi679qtv">
                <span className="font-bold text-ink" data-id="element-51" data-mp="2fmcxb9r3m28i">{notice.name}</span> from {notice.country} {notice.flag} just purchased{" "}
                <span className="font-semibold text-brand-deep" data-id="element-52" data-mp="2kko75khe8cqq">Post-Endodontic Restoration Blueprint™</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] font-medium text-slate-500" data-id="element-53" data-mp="1ry3jau04mirx">
                <BadgeCheckIcon className="h-3.5 w-3.5 text-ok" aria-hidden data-id="element-54" data-mp="1wx6dfjekj4l4" />
                Verified purchase · {notice.minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-slate-400 transition-colors duration-150 hover:text-slate-700" aria-label="Close notification" data-id="element-55" data-mp="21u6grmk19t8j">
              <XIcon className="h-4 w-4" data-id="element-56" data-mp="1e4ucn13kcbd3" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}